/**
 |--------------------------------------------------------------------------
 | CONTACTS : Vue-Router Routes
 |--------------------------------------------------------------------------
 */
const contacts = [
 {
  path: '/contacts/all', component: require('pages/companies/contacts/all.vue').default,
  name: 'all_contacts',
  meta: {requiresAuth: true, title: "All Contacts", icon: "fas fa-user-tie"}
 }, {
  path: '/contact/profile', component: require('pages/companies/contacts/profile.vue').default,
  name: 'contact_profile',
  meta: {requiresAuth: true, title: "Contact Profile", icon: "fas fa-id-badge"}
 },
 // {
 //  path: '/contacts/search', component: require('pages/contacts/search.vue').default,
 //  name: 'search_contacts',
 //  meta: {
 //   requiresAuth: true,
 //   authLevelRequired: userLevelGroups.crm_man_ac_con,
 //   title: "Search Contacts",
 //   icon: "fas fa-search"
 //  }
 // }, {
 //  path: '/contacts/create', component: require('pages/contacts/create.vue').default,
 //  name: 'create_contact',
 //  meta: {
 //   requiresAuth: true,
 //   authLevelRequired: userLevelGroups.crm_man_ac_con,
 //   title: "Create Contact",
 //   icon: "fas fa-id-card"
 //  }
 // },
];
export default contacts;
